import { tns } from 'tiny-slider/src/tiny-slider';

/**
 * Testimonials slider (Testimonials block, "Slider" display type).
 *
 * On desktop the quotes rotate on their own (client QA TPN-36) so visitors
 * see every testimonial without clicking the arrows. Rotation:
 * - only starts at the large breakpoint (1025px and up), matching the theme's
 *   $large SCSS variable, so phones and tablets keep manual swiping;
 * - pauses while the pointer is over the slider or keyboard focus is inside
 *   the block, so people can finish reading;
 * - never starts when the visitor prefers reduced motion.
 */

// Matches $large in css/variables.scss.
const DESKTOP_QUERY = '(min-width: 1025px)';

// Long quotes need time to read, so each slide stays up for 8 seconds.
const AUTOPLAY_TIMEOUT_MS = 8000;

class TestimonialsSlider {
	constructor(el, prevButton, nextButton) {
		this.el = el;
		this.prevButton = prevButton;
		this.nextButton = nextButton;

		const prefersReducedMotion = window.matchMedia
			&& window.matchMedia('(prefers-reduced-motion: reduce)').matches;
		const isDesktop = window.matchMedia && window.matchMedia(DESKTOP_QUERY).matches;
		const shouldAutoplay = isDesktop && !prefersReducedMotion;

		const testimonialsSlider = tns({
			container: this.el,
			items: 1,
			slideBy: 1,
			mode: "gallery",
			autoplay: shouldAutoplay,
			autoplayTimeout: AUTOPLAY_TIMEOUT_MS,
			autoplayHoverPause: true,
			autoplayButtonOutput: false,
			speed: 400,
			controls: true,
			prevButton: this.prevButton,
			nextButton: this.nextButton
		});

		if (shouldAutoplay && testimonialsSlider) {
			this.pauseWhileFocused(testimonialsSlider);
		}

		return testimonialsSlider;
	}

	/**
	 * Pause rotation while keyboard focus is inside the block (for example on
	 * the arrow buttons or a link in a quote) and resume when focus leaves.
	 *
	 * @param {Object} slider tiny-slider instance.
	 */
	pauseWhileFocused(slider) {
		const block = this.el.closest('.block-testimonials') || this.el;

		block.addEventListener('focusin', () => slider.pause());
		block.addEventListener('focusout', (event) => {
			if (!block.contains(event.relatedTarget)) {
				slider.play();
			}
		});
	}
}

export default TestimonialsSlider;
